<template>
  <div class="approve">
<!--    <span v-for="(item, index) in approveText" :key="item.id" @click="approve(item.content)">{{item.content}}<em v-if="index !== approveText.length - 1">/</em>-->
<!--    </span>-->
    <el-radio-group v-model="text">
      <el-radio @change="approve" v-for="(item) in approveText" :key="item.id" :label="item.content">{{item.content}}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "fastApprove",
  data() {
    return{
      approveText: [],
      text: ''
    }
  },
  created() {
    this.getList();
  },
  methods:{
    getList() {
      this.$ajax.get(this.$api.allCustomList, {
        SettingType: 0
      }).then(res => {
        this.approveText = res.data;
      })
    },
    approve(t){
      this.$emit('approveText', t);
    }
  }
}
</script>

<style scoped lang='scss'>
  .approve{
    text-align: left;
    line-height: 1;
    padding-top: 10px;
    span{
      cursor: pointer;
      em{
        font-style: normal;
        margin: 0 3px;
      }
    }
  }
</style>